<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class="arch">
            <p fade="click" ref="acoustic" speed="fast">I look across to the hill I climbed yesterday, I can clearly see the tower, and I realise I have seen this same view before, in <i>my city</i>, and there as here, it is a folly. A monument to <i>dreams </i> and to ideas without any thought as to futurity. That strikes me as funny, even tragic, considering what is to come.
            In your city, there is a tower. In mine, or what I remember is mine, there are six deep stone dishes arranged to face the sky. Each directed toward a specific zone of the heavens, each waiting for a noise that our ears will never hear; the sound of creation speaking back to us. Imagine a dome, inverted and swung around its axis until the dish opens up to the night. These look from below, from our perspective, like the petals of a huge flower open above us. And we walk toward them and wonder.
            I walked past these from time to time when I lived there, and I never imagined what song they might create.
            <br>
            <br>
            Now,
            <br>
            <br>
            stood between <a @click="fade">two worlds</a><br></p>
            <p>I can hear their melody.
            <br>
            <br>
            A terrible shouting, voices crying and lamenting.<br>
            <br>
            Creation, it might suggest, is weeping. </p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Acoustic Astronomy'
    }
  },
  methods: {
    fade () {
      this.$emit('fade', ['acoustic', 'fast'])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
